<template>
  <div class="list_breadcrumb">
    <span class="hover" @click="to1()">{{ value1 }}</span> ＞
    <span class="hover" @click="to2()">{{ value2 }}</span> <span v-if="name!='xzlm'">＞</span>
    <span class="hover" @click="to3()">{{ value3 }}</span
    ><template v-if="value4">
      ＞ <span class="hover">{{ value4 }}</span></template
    >
  </div>
</template>

<script>
export default {
  name: "list_breadcrumb",
  data() {
    return {
      name:null
    };
  },
  created(){
    this.name=this.$route.name
  },
  props: ["value1", "value2", "value3", "value4", "url"],
  methods: {
    to1() {
      location.href = "index.html";
    },
    to2() {
      console.log(this.url);
      let ljcode = this.url ? this.url[0] : this.$route.query.ljcode;
      let rootColumnId = this.url
        ? this.url[1]
        : this.$route.query.rootColumnId;
      let columnId = this.url ? this.url[2] : this.$route.query.columnId;
      if (rootColumnId == "2c9a4c9b6ea63d8c016ea6409e450001") {
        ljcode = "shop";
      }
      switch (ljcode) {
        case "shop":
            let url = window.location.href.split('shop.html')
            console.log(url[0])
            window.location.replace(`${url[0]}shop.html#/xlyd?columnId=8a9d2ba16f64df6e016f787cf46b000c&rootColumnId=2c9a4c9b6ea63d8c016ea6409e450001`)
      }
      switch (rootColumnId) {
        case "40288a9d6e91c70a016e91c787ba0000":
          this.$router.push({
            path: `list1?ljcode=ljgl&columnId=40288a9d6e91c70a016e91cabebd0006&rootColumnId=40288a9d6e91c70a016e91c787ba0000`,
          });
          break;
        case "40288a9d6e91c70a016e91c895ae0001":
          this.$router.push({
            path: `vr?ljcode=720&columnId=40288a9d6e91c70a016e91cc6eb5000a&rootColumnId=40288a9d6e91c70a016e91c895ae0001`,
          });
          break;
        case "40288a9d6e91c70a016e91c90be20002":
          this.$router.push({
            path: `list_wzlj?ljcode=ms&columnId=40288a9d6e91c70a016e91cd018f000b&rootColumnId=40288a9d6e91c70a016e91c90be20002`,
          });
          break;
        case "40288a9d6e91c70a016e91c947000003":
          this.$router.push({
            path: `tyfg?ljcode=tyfg&columnId=40288a9d6e91c70a016e91cecf5a0012&rootColumnId=40288a9d6e91c70a016e91c947000003`,
          });
          break;
        case "40288a9d6e91c70a016e91c982fd0004":
          this.$router.push({
            path: `lygl?ljcode=lygl&columnId=40288a9d6e91c70a016e91cf71920015&rootColumnId=40288a9d6e91c70a016e91c982fd0004`,
          });
          break;
        // case "2c9a4c9b6ea63d8c016ea6409e450001":
        //   this.$router.push({
        //     path: `shop.html#/xlyd?columnId=8a9d2ba16f64df6e016f787cf46b000c&rootColumnId=2c9a4c9b6ea63d8c016ea6409e450001`,
        //   });
        //   break;
        case "40288a9d6e91c70a016e91ca6a640005":
          this.$router.push({
            path: `lyzn?ljcode=lyzn&articleId=8a9d2ba16ec4607c016ec52657500000&columnId=40288a9d6e91c70a016e91d09edb0019&rootColumnId=40288a9d6e91c70a016e91ca6a640005`,
          });
          break;
      }
      //this.$router.push({path:})
      //  console.log(this.url);
    },

    to3() {
      console.log(this.url, 12156481654);
      let ljcode = this.url ? this.url[0] : this.$route.query.ljcode;
      let rootColumnId = this.url
        ? this.url[1]
        : this.$route.query.rootColumnId;
      let columnId = this.url ? this.url[2] : this.$route.query.columnId;
      let title = this.url[3];
      if (rootColumnId == "2c9a4c9b6ea63d8c016ea6409e450001") {
        ljcode = "shop";
      }
      switch (ljcode) {
        case "shop":
          location.href =
            "shop.html#/xlyd?columnId=8a9d2ba16f64df6e016f787cf46b000c&rootColumnId=2c9a4c9b6ea63d8c016ea6409e450001";
          break;
         //了解廉江 
        case "ljgl":
          this.$router.push({
            path: `list1?ljcode=ljgl&columnId=40288a9d6e91c70a016e91cabebd0006&rootColumnId=40288a9d6e91c70a016e91c787ba0000`,
          });
          break;
        case "ljdt":
          this.$router.push({
            path: `list2?ljcode=ljdt&columnId=40288a9d6e91c70a016e91caf27c0007&rootColumnId=40288a9d6e91c70a016e91c787ba0000`,
          });
          break;
        case "jqhd":
          this.$router.push({
            path: `jqhd?ljcode=${ljcode}&columnId=${columnId}&rootColumnId=${rootColumnId}`,
          });
          break;
        case "yhlj":
          this.$router.push({
            path: `yhlj?ljcode=${ljcode}&columnId=${columnId}&rootColumnId=${rootColumnId}`,
          });
          break;
        //虚拟游
          case "720":
          this.$router.push({
            path: `vr?ljcode=${ljcode}&columnId=${columnId}&rootColumnId=${rootColumnId}`,
          });
          break;
        case "myjj":
          this.$router.push({
            path: `myjj?ljcode=${ljcode}&columnId=${columnId}&rootColumnId=${rootColumnId}`,
          });
          break;
      
        case "cjqh":
          this.$router.push({
            path: `cjqh?ljcode=cjqh&rootColumnId=40288a9d6e91c70a016e91c895ae0001&columnId=cjqh`,
          });
          break;
        //玩转廉江
        case "cx":
          this.$router.push({
            path: `list_wzlj_cx?ljcode=cx&columnId=40288a9d6e91c70a016e91cd57a1000d&rootColumnId=40288a9d6e91c70a016e91c90be20002`,
          });
          break;
        //廉江特色
         case 'tyfg':
           this.$router.push({
            path: `tyfg?ljcode=${ljcode}&columnId=${columnId}&rootColumnId=${rootColumnId}`,
          });
          break;   
           case 'shgn':
           this.$router.push({
            path: `shgn?ljcode=${ljcode}&columnId=${columnId}&rootColumnId=${rootColumnId}`,
          });
          break; 
           case 'mlxc':
           this.$router.push({
            path: `mlxc?ljcode=${ljcode}&columnId=${columnId}&rootColumnId=${rootColumnId}`,
          });
          break; 
        //互动交流
           case 'lygl':
           this.$router.push({
            path: `lygl?ljcode=${ljcode}&columnId=${columnId}&rootColumnId=${rootColumnId}`,
          });
          break; 
           case 'yjfx':
           this.$router.push({
            path: `${ljcode}?ljcode=${ljcode}&columnId=${columnId}&rootColumnId=${rootColumnId}`,
          });
          break; 
           case 'xcgh':
           this.$router.push({
            path: `${ljcode}?ljcode=${ljcode}&columnId=${columnId}&rootColumnId=${rootColumnId}`,
          });
          break; 
           case 'lyxl':
           this.$router.push({
            path: `${ljcode}?ljcode=${ljcode}&columnId=${columnId}&rootColumnId=${rootColumnId}`,
          });
          break; 
        //在线预订
          case 'xlyd':
           this.$router.push({
            path: `${ljcode}?ljcode=${ljcode}&columnId=${columnId}&rootColumnId=${rootColumnId}`,
          });
          break;
          case 'jqyd':
           this.$router.push({
            path: `${ljcode}?ljcode=${ljcode}&columnId=${columnId}&rootColumnId=${rootColumnId}`,
          });
          break;
          case 'jdyd':
           this.$router.push({
            path: `${ljcode}?ljcode=${ljcode}&columnId=${columnId}&rootColumnId=${rootColumnId}`,
          });
          break;
      }
      switch (title) {
        case "ms":
          this.$router.push({
            path: `list_wzlj?ljcode=ms&columnId=${columnId}&rootColumnId=${rootColumnId}`,
          });
          break;
        case "zs":
          this.$router.push({
            path: `list_wzlj_zs?ljcode=zs&columnId=${columnId}&rootColumnId=${rootColumnId}`,
          });
          break;
        case "yw":
          this.$router.push({
            path: `list_wzlj_yw?ljcode=yw&columnId=${columnId}&rootColumnId=${rootColumnId}`,
          });
          break;
        case "gw":
          this.$router.push({
            path: `list_wzlj_gw?ljcode=gw&columnId=${columnId}&rootColumnId=${rootColumnId}`,
          });
          break;
        case "yl":
          this.$router.push({
            path: `list_wzlj_yl?ljcode=yl&columnId=${columnId}&rootColumnId=${rootColumnId}`,
          });
          break;
        case "tc":
          this.$router.push({
            path: `list_wzlj_tc?ljcode=tc&columnId=${columnId}&rootColumnId=${rootColumnId}`,
          });
          break;
        case "jd":
          this.$router.push({
            path: `list_wzlj_jd?ljcode=jd&columnId=${columnId}&rootColumnId=${rootColumnId}`,
          });
          break;
      }
    },
  },
};
</script>

<style lang="less" scoped>
.list_breadcrumb {
  height: 55px;
  line-height: 55px;
  text-align: left;
  font-size: 16px;
  color: #666666;
  border-bottom: 1px solid rgba(215, 220, 226, 1);
  font-weight: 600;
}
</style>
